/**
 * 预约表单步骤
 */
export const RESERVE_STEP_INDEX = {
  RESERVE_ITEMS: 1,
  TIME_STORE: 2,
  CONTACT_INFO: 3,
}

// 维保类型 code
export const MAINTANCE_TYPE_CODE = {
  CHECK: 21,
  REPAIR: 22,
  ACCIDENT_REPAIR: 31, // 事故维修（后端 /maintenance/home/index 返回）
}

// 事故维修二级项目 code（后端 /maintenance/home/index 返回）
export const ACCIDENT_REPAIR_SUB_CODE = {
  SELF_PAY: 311, // 自费
  INSURANCE: 312, // 保险
}

// 事故维修「费用类型」：仅用于消费后端 collectInfo.feeType（详情展示 / 编辑态回显）。
// 提交与查询已改为通过子项 code 311/312 传递，前端不再下发 feeType；后端据子项自行维护 feeType/feeTypeDesc。
export const FEE_TYPE = {
  SELF_PAY: 1, // 自费
  INSURANCE: 2, // 保险
} as const;

export type FeeTypeValue = typeof FEE_TYPE[keyof typeof FEE_TYPE]; // 1 | 2

// 归一化后端 feeType：数字或纯数字字符串 → 1/2；其余（null/undefined/空串/-1/非法值）→ null
export const toFeeType = (v: unknown): FeeTypeValue | null => {
  const n =
    typeof v === "number"
      ? v
      : typeof v === "string" && v.trim() !== ""
      ? Number(v)
      : NaN;
  return n === FEE_TYPE.SELF_PAY || n === FEE_TYPE.INSURANCE
    ? (n as FeeTypeValue)
    : null;
};

// 能否重现异响（noiseInfo.noiseRecurrent / 提交 reqData.noiseRecurrent）：后端有效值仅以下两个，
// 其余返回值（含 null / -1 / 其它）一律视为「未填」。
export const NOISE_RECURRENT = {
  NO: 0, // 否
  YES: 1, // 是
} as const;

export type NoiseRecurrentValue = typeof NOISE_RECURRENT[keyof typeof NOISE_RECURRENT]; // 0 | 1

// 归一化后端 noiseRecurrent：数字或纯数字字符串 → 0/1；其余（null/undefined/空串/-1/非法值）→ null
export const toNoiseRecurrent = (v: unknown): NoiseRecurrentValue | null => {
  const n =
    typeof v === "number"
      ? v
      : typeof v === "string" && v.trim() !== ""
      ? Number(v)
      : NaN;
  return n === NOISE_RECURRENT.NO || n === NOISE_RECURRENT.YES
    ? (n as NoiseRecurrentValue)
    : null;
};

// 维修二级项目「异响」code（后端 /maintenance/home/index 返回）
export const NOISE_SUB_CODE = 103;

// 维修二级项目「其他」code（无需填写问题描述反馈）
export const REPAIR_OTHER_SUB_CODE = 108;

// 维修二级项目「外观/内饰」code（后端 /maintenance/home/index 返回）
export const APPEARANCE_SUB_CODE = 104;

// 「最近一次问题时间」不露出的故障维修二级项 code
// 仅 异响/震动(103)、外观/内饰(104) 无需露出；其余（含 其他108）均露出且必填
export const NO_LAST_ISSUE_TIME_CODES: number[] = [
  NOISE_SUB_CODE, // 103 异响/震动
  APPEARANCE_SUB_CODE, // 104 外观/内饰
];

// 「最近一次问题时间」露出即必填：除上述 code 外的故障维修二级项均露出且必填
export const shouldShowLastIssueTime = (code: number): boolean =>
  !NO_LAST_ISSUE_TIME_CODES.includes(code);

// BaseCode 类型名：预约项目提示开关（RESERVE_ITEM_ALERT_FLAG）
// 该 type 下 code："1"=新建预约点「下一步」时提示补全维修项目，"0"=不提示
export const RESERVE_ITEM_ALERT_FLAG_TYPE = 'RESERVE_ITEM_ALERT_FLAG';

export const DEFAULT_CITY_CODE = '440106'; // 广州
export const DEFAULT_CITY = '广州'; // 广州

// 预约单状态
export enum RESERVE_ORDER_STATUS {
  SUCCESS = 1,
  RESERVE_CANCEL = 5,
  ARRIVED = 6,
  RESERVE_SUCCESS = 7,
}

export const TAB_ID_SET = {
  DATE_TAB: 0,
  STORE_TAB: 1,
}
// 预约门店及时间 tab 内容
export const STORE_TIME_TAB_LIST = [
  {
    id: TAB_ID_SET.DATE_TAB,
    name: '按日期'
  },
  {
    id: TAB_ID_SET.STORE_TAB,
    name: '按门店'
  },
]

// 预约失败枚举文案映射
export const RESERVE_FAIL_TEXT_MAP = {
  42103: '已存在预约单，无需重复预约',
  42115: '没有取送车权益，请确认取送车权益可用次数大于0',
  46105: '非常抱歉，订单无法创建请尝试重新提交，或联系客服',
  42107: '为提供更好的服务，暂不开放预约当天时间',
  42109: '预约已满，请更新预约日期或选择其他门店',
  42106: '预约失败，请返回修改后再次提交，或者联系客服咨询',
  42114: '修改失败，请重新预约或者联系客服咨询'
}

export const ORDER_TAB_MAP = {
  COMPREHENSIVE: 0,
  DISTANCE: 1
}

export const ORDER_TAB_LIST = [
  {
    id: ORDER_TAB_MAP.COMPREHENSIVE,
    name: '综合排序'
  },
  {
    id: ORDER_TAB_MAP.DISTANCE,
    name: '距离优先'
  }
]
